require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-brook-riggio-and-john-bender.json") })
        }
      }, "path---blog-author-brook-riggio-and-john-bender");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-brook-riggio-and-john-bender!./.cache/json/blog-author-brook-riggio-and-john-bender.json
// module id = 615
// module chunks = 231608221292675